import {actions as A} from '../../constants/actions';

const prevCompletedStepSignTrue = () => {
  return (dispatch) => {
    dispatch({
      type: A.PREVIOUSLY_COMPLETED_STEP_SIGN_TRUE,
    });
  }
};

export {prevCompletedStepSignTrue}
